<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from "vue";

const isChatOpen = ref(false);
const toggleChat = () => {
  isChatOpen.value = !isChatOpen.value;
};
const closeChat = () => {
  isChatOpen.value = false;
};

const applyViewportVars = () => {
  const vv = window.visualViewport;
  const height = vv ? vv.height : window.innerHeight;
  const offsetTop = vv ? vv.offsetTop : 0;
  const offsetLeft = vv ? vv.offsetLeft : 0;

  document.documentElement.style.setProperty("--chat-vv-height", `${height}px`);
  document.documentElement.style.setProperty("--chat-vv-top", `${offsetTop}px`);
  document.documentElement.style.setProperty("--chat-vv-left", `${offsetLeft}px`);
  document.documentElement.style.setProperty("--chat-vv-extra", "4px");
};

const onViewportChange = () => {
  applyViewportVars();
  if (isChatOpen.value) {
    document.body.classList.toggle("chat-window-open", isMobile());
  }
};

const isMobile = () => window.matchMedia("(max-width: 479px)").matches;

const handleMessage = (event) => {
  if (!event.data) return;
  if (event.data === "close-chat") closeChat();
};

onMounted(() => {
  window.addEventListener("message", handleMessage);
  applyViewportVars();
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", onViewportChange);
    window.visualViewport.addEventListener("scroll", onViewportChange);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("message", handleMessage);
  if (window.visualViewport) {
    window.visualViewport.removeEventListener("resize", onViewportChange);
    window.visualViewport.removeEventListener("scroll", onViewportChange);
  }
});

watch(isChatOpen, (open) => {
  document.body.classList.toggle("chat-window-open", open && isMobile());
  if (open) {
    applyViewportVars();
  }
});
</script>

<template>
  <div data-chatbtn="" class="code-embed-3 chat-btn w-embed" bis_skin_checked="1">
    <button
      class="chat-button"
      id="chatButton"
      type="button"
      :class="{ 'is--visible': isChatOpen }"
      @click="toggleChat"
    >
      <div class="chat-button__icon chat-button__icon--chat" bis_skin_checked="1">
        <svg class="chat-icon" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"></path>
        </svg>
      </div>
      <div class="chat-button__icon chat-button__icon--close" bis_skin_checked="1">
        <svg class="close-icon" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
        </svg>
      </div>
    </button>
  </div>
  <div
    data-chatwindow=""
    class="chat-window code-embed w-embed w-iframe"
    :class="{ 'is--visible': isChatOpen }"
    bis_skin_checked="1"
  >
    <iframe
      src="https://pipelogic-chat.ipnet.ua/"
      style="width: 100%; height: 100%; border: none;"
      title="Chat Widget"
      bis_size="{&quot;x&quot;:0,&quot;y&quot;:5458,&quot;w&quot;:297,&quot;h&quot;:607,&quot;abs_x&quot;:0,&quot;abs_y&quot;:5458}"
      bis_id="fr_e2zs6cndnadscmj78vycoy"
      bis_depth="0"
      bis_chainid="1"
    >
      <p>
        Ваш браузер не поддерживает iframe.
        <a href="bernice-unstipulated-antonio.ngrok-free.dev" target="_blank">
          Открыть чат в новой вкладке
        </a>
      </p>
    </iframe>
  </div>
</template>

<style lang="scss">
@use '@/assets/scss/components/chat-widget';
</style>
